import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker'
import logout from '../../Global/logout'

export default async function GetProviders(activePage, pageSize, activeOnly) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let queryData = "?page=" + activePage + 
    "&size=" + pageSize

    if(activeOnly === "Active"){
        queryData += "&onlyActive=true"
    }
    else if(activeOnly === "Inactive"){
        queryData += "&onlyActive=false"
    }
    

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider'  + queryData, {
            method: 'GET',
            headers: { 'Authorization' : unHashedJwt}         
        }).then(
            res => (res)
        ).catch(error => error.response.data.status === 401 ? logout() : error.response.data)
    )
}